import React, { Component } from 'react'
import { HashRouter, Route, Switch } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import jQuery from 'jquery'
import jsPDF from 'jspdf'
import './css/app.css'
import 'react-notifications/lib/notifications.css'
import Loading from './containers/Loading'
import { registerLocale, setDefaultLocale } from 'react-datepicker'
import th from 'date-fns/locale/th'
import RouteChangeTracker from './RouteChangeTracker'
registerLocale('th', th)
setDefaultLocale('th')

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const BackOffice = React.lazy(() => import('./containers/TheLayout'))
const FrontOffice = React.lazy(() => import('./container-front/TheLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/UIBackOfficeLogin'))
const Referral = React.lazy(() => import('./views/front-office/referral/referral'))
const PDF = React.lazy(() => import('./views/back-office/candidate/candidate-pdf/CandidateMainPDF'))
const ExamIMEIPDF = React.lazy(() => import('./views/back-office/OnlineForm/ResignRequest/PDF/ExampleIMEIPDF'))
const ContractTSRPDF = React.lazy(() => import('./views/full-app/ContractPDF/ContractTSR/ContractTSRPDF'))
const BrokerContractSABPDF = React.lazy(() =>
  import('./views/full-app/ContractPDF/ContractSAB/BrokerContractPDF/BrokerContractSABPDF')
)
const SABLetterofIntentPDF = React.lazy(() =>
  import('./views/full-app/ContractPDF/ContractSAB/LetterofIntent/SABLetterofIntentPDF')
)
const ContractPCPDF = React.lazy(() => import('./views/full-app/ContractPDF/ContractPC/ContractPCPDF/ContractPCPDF'))
const BrokerContractPCPDF = React.lazy(() =>
  import('./views/full-app/ContractPDF/ContractPC/BrokerContracPCPDF/BrokerContractPCPDF')
)
const MoreContractPCPDF = React.lazy(() =>
  import('./views/full-app/ContractPDF/ContractPC/MoreContractPCPDF/MoreContractPCPDF')
)
const SessionExpire = React.lazy(() => import('./views/pages/login/UISessionExpire'))
const Maintenance = React.lazy(() => import('./views/pages/MaintenancePage/UIMaintenancePage'))
window.jQuery = jQuery
window.jsPDF = jsPDF

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Loading />
        <RouteChangeTracker />
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/back-office/login" name="Login Page" render={(props) => <Login {...props} />} />
            <Route exact path="/referral" name="Referral" render={(props) => <Referral {...props} />} />
            <Route exact path="/Session-Expire" name="Session-Expire" render={(props) => <SessionExpire {...props} />} />
            <Route
              exact
              path="/back-office/print/candidate-pdf"
              name="candidate-pdf"
              render={(props) => <PDF {...props} />}
            />
            <Route
              exact
              path="/back-office/print/sab/broker-contract"
              name="candidate-pdf"
              render={(props) => <BrokerContractSABPDF {...props} />}
            />
            <Route
              exact
              path="/back-office/print/sab/letter-of-intent"
              name="candidate-pdf"
              render={(props) => <SABLetterofIntentPDF {...props} />}
            />
            <Route
              exact
              path="/back-office/print/pc/contract"
              name="candidate-pdf"
              render={(props) => <ContractPCPDF {...props} />}
            />
            <Route
              exact
              path="/back-office/print/pc/broker-contract"
              name="candidate-pdf"
              render={(props) => <BrokerContractPCPDF {...props} />}
            />
            <Route
              exact
              path="/back-office/print/pc/more-contract"
              name="candidate-pdf"
              render={(props) => <MoreContractPCPDF {...props} />}
            />
            <Route
              exact
              path="/back-office/print/tsr/contract"
              name="candidate-pdf"
              render={(props) => <ContractTSRPDF {...props} />}
            />
            <Route
              exact
              path="/back-office/print/tsc/contract"
              name="candidate-pdf"
              render={(props) => <ContractTSRPDF {...props} />}
            />
            <Route
              exact
              path="/back-office/print/examimei"
              name="Exam-IMEI-PDF"
              render={(props) => <ExamIMEIPDF {...props} />}
            />
            <Route exact path="/Maintenance" name="Maintenance" render={(props) => <Maintenance {...props} />} />
            <Route path="/back-office/" name="Back-office" render={(props) => <BackOffice {...props} />} />
            <Route path="/" name="Home" render={(props) => <FrontOffice {...props} />} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    )
  }
}

export default App
